import { createApp } from "vue";
import RecordingCropApp from "./RecordingCropApp.vue";

if (document.querySelector('#recording_crop_app')) {
  const app = createApp(RecordingCropApp)
  app.mount('#recording_crop_app');
}
